import { useRouter } from "vue-router/composables";
import {logout as logoutRest} from "../api/rest";

export const logout = () => {
    logoutRest();
    const router = useRouter();
    router.push("/login");
};


export const isTestEnvironment = () => !import.meta.env.PROD;

export const isManagement = (user) => user?.role?.type === "x_cube_management";

export const isOperatorAdmin = (user) => user?.role?.type === "x_cube_operator_admin";

export const isOperator = (user) => user?.role?.type === "x_cube_operator";

export const isHubUser = (user) => isManagement(user) || isOperatorAdmin(user) || isOperator(user);